import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  imageDiv: {
    width: '100%',
    '& img': {
      maxWidth: '100%',
    },
    marginBottom: theme.spacing(2),
  },
  img: {
    maxWidth: '100%',
    width: '100%',
  },
  arrow: {
    lineHeight: 0,
    position: 'absolute',
    color: '#000',
    cursor: 'pointer',
    top: '50%',
    transform: 'translateY(-50%)',
    borderRadius: '100%',
    '&.--right': {
      right: -30,
    },
    '&.--left': {
      left: -30,
    },
    '&.--disabled': {
      display: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      '&.--right': {
        right: -20,
      },
      '&.--left': {
        left: -20,
      },
    },
  },
}));
